// Estoque livre na venda (backend services/estoque_livre): o livre da filial de saída vem AO VIVO do Tiny
// (saldo - reservado); as outras filiais, da base local, só como informação.

// Cartões do "Estoque do último item buscado": a filial de saída primeiro, com saldo, reservado e livre.
export function cartaoDeEstoque({ estoques = {}, saida = null } = {}) {
  const outras = Object.entries(estoques)
    .filter(([filial]) => filial !== saida?.filial)
    .map(([filial, saldo]) => ({ empresa_nome: filial, saida: false, saldo, saldo_reservado: 0, saldo_disponivel: saldo }));
  if (!saida) return outras;
  return [
    { empresa_nome: saida.filial, saida: true, saldo: saida.saldo, saldo_reservado: saida.reservado,
      saldo_disponivel: Math.max(saida.disponivel, 0) },
    ...outras,
  ];
}

// 409 "sem_estoque" do POST /pedidos e da conversão de proposta: as faltas, ou null se o erro é outro.
export function faltasDoErro(e) {
  const detail = e?.response?.status === 409 ? e.response.data?.detail : null;
  return detail?.codigo === 'sem_estoque' ? detail.faltas : null;
}

// Confirmação da venda sem estoque livre (criar pedido e converter proposta): o texto e uma linha por item.
export const AVISO_VENDA_SEM_ESTOQUE = 'A filial de saída não tem estes itens livres (já descontado o que está '
  + 'reservado para outros pedidos). Se seguir, o pedido vai como encomenda e chega ao Tiny marcado como venda sem estoque.';

export const linhasDeFalta = (faltas) =>
  faltas.map((f) => `${f.nome || f.sku}: pedido ${f.quantidade}, livre ${f.disponivel} na ${f.filial}`);
